import { QueryFunctionContext } from '@tanstack/react-query';

import { baseQuery } from '../baseQuery';
import type { SubscriptionJob } from 'types';

type SubscriptionJobsResponse = {
  data: SubscriptionJob[];
  total: number;
  current_page: number;
  last_page: number;
  per_page: number;
  total_hours: number;
};

export const getSubscriptionJobs = async ({
  queryKey,
}: QueryFunctionContext<[string, number | undefined, number]>) => {
  const subscriptionId = queryKey[1];
  const page = queryKey[2];

  const response: SubscriptionJobsResponse = await baseQuery(`subscriptions/${subscriptionId}/jobs?page=${page}`);

  return response;
};
